const desc = `<body class="c5 doc-content">
  <p class="c3" dir="rtl">
    <span class="c4">נחמה פוחצ&#39;בסקי ז"ל (תולדותיה)</span
    ><span class="c1"> </span><span class="c2 bold">דואר היום</span
    ><span class="c0">  1934 06 15</span>
  </p>
</body>`;

export default desc;
